document.addEventListener("DOMContentLoaded", function () {

  // --- Nyelv lekérése ---
  const lang = document.documentElement.lang;

  // --- Szövegek nyelvenként ---
  const texts = {
    hu: {
      copy: "Másolás vágólapra →",
      copied: "Email cím másolva a vágólapra!"
    },
    de: {
      copy: "In Zwischenablage kopieren →",
      copied: "E-Mail-Adresse in die Zwischenablage kopiert!"
    },
    en: {
      copy: "Copy to clipboard →",
      copied: "Email address copied to clipboard!"
    },
    sk: {
      copy: "Skopírovať do schránky →",
      copied: "Emailová adresa bola skopírovaná do schránky!"
    }
  };

  const t = texts[lang] || texts.hu;

  function createPopup(emailLinkSelector) {

    const emailLink = document.querySelector(emailLinkSelector);

    if (!emailLink) return;

    const overlay = document.createElement("div");
    overlay.classList.add("overlay-popup");
    document.body.appendChild(overlay);

    const popup = document.createElement("div");
    popup.classList.add("email-popup");
    popup.innerHTML = `
      <button class="popup-close">X</button>
      <a href="mailto:iroda@czingerhome.hu">iroda@czingerhome.hu</a>
      <button class="copy-btn">${t.copy}</button>
    `;

    document.body.appendChild(popup);

    const closeButton = popup.querySelector(".popup-close");
    const copyButton = popup.querySelector(".copy-btn");

    function openPopup(event) {
      event.preventDefault();

      overlay.style.display = "block";
      popup.style.display = "block";
    }

    emailLink.addEventListener("click", openPopup);

    closeButton.addEventListener("click", () => {
      overlay.style.display = "none";
      popup.style.display = "none";
    });

    overlay.addEventListener("click", () => {
      overlay.style.display = "none";
      popup.style.display = "none";
    });

    copyButton.addEventListener("click", () => {
      navigator.clipboard.writeText("iroda@czingerhome.hu")
        .then(() => {
          alert(t.copied);
        });
    });
  }

  createPopup("#shopify-section-template--20826984841405__richtext_LWkJPF > div > div > div > div > div > p:nth-child(3) > a");
  createPopup("#shopify-section-template--21531431305405__richtext_gQ7rtK > div > div > div > div > div > p:nth-child(3) > a");

});









document.querySelectorAll('.image-with-text-section').forEach(section => {
  const hasRealImage = section.querySelector('.image-with-text-media img, .image-with-text-media video');
  const hasText = [...section.querySelectorAll('.image-with-text-content h1, .image-with-text-content h2, .image-with-text-content h3, .image-with-text-content h4, .image-with-text-content h5, .image-with-text-content h6, .image-with-text-content p, .image-with-text-content .rte, .image-with-text-content a')]
    .some(el => el.textContent.trim() !== '');

  if (!hasRealImage || !hasText) {
    section.style.display = 'none';
  }
});





document.addEventListener('DOMContentLoaded', function () {
  const block = document.querySelector('#shopify-block-AcDlpQjdEeEkxUTBzS__custom_grid_video_abCdRg');

  if (block) {
    block.style.cursor = 'pointer';

    block.addEventListener('click', function () {
      window.open('https://czingerhome.hu/pages/rolunk', '_blank');
    });
  }
});








document.addEventListener("DOMContentLoaded", function () {

  // --- Nyelv lekérése ---
  const lang = document.documentElement.lang;

  // --- Szövegek nyelvenként ---
  const texts = {
    hu: {
      copy: "Másolás vágólapra →",
      copied: "Telefonszám másolva a vágólapra!"
    },
    de: {
      copy: "In Zwischenablage kopieren →",
      copied: "Telefonnummer in die Zwischenablage kopiert!"
    },
    en: {
      copy: "Copy to clipboard →",
      copied: "Phone number copied to clipboard!"
    }
  };

  const t = texts[lang] || texts.hu;

  function createPopup(emailLinkSelector) {

    const emailLink = document.querySelector(emailLinkSelector);

    if (!emailLink) return;

    const overlay = document.createElement("div");
    overlay.classList.add("overlay-popup");
    document.body.appendChild(overlay);

    const popup = document.createElement("div");
    popup.classList.add("email-popup");
    popup.innerHTML = `
      <button class="popup-close">X</button>
      <a href="tel:+36202228620">+36 20 222 8620</a>
      <button class="copy-btn">${t.copy}</button>
    `;

    document.body.appendChild(popup);

    const closeButton = popup.querySelector(".popup-close");
    const copyButton = popup.querySelector(".copy-btn");

    function openPopup(event) {
      event.preventDefault();

      overlay.style.display = "block";
      popup.style.display = "block";
    }

    emailLink.addEventListener("click", openPopup);

    closeButton.addEventListener("click", () => {
      overlay.style.display = "none";
      popup.style.display = "none";
    });

    overlay.addEventListener("click", () => {
      overlay.style.display = "none";
      popup.style.display = "none";
    });

    copyButton.addEventListener("click", () => {
      navigator.clipboard.writeText("+36202228620")
        .then(() => {
          alert(t.copied);
        });
    });
  }

  createPopup("#shopify-section-template--20826984972477__main .phone-box a");
  createPopup("#shopify-section-template--20826984972477__richtext_T6mb9M > div > div > div > div > div.richtext-btn > a");

});


document.addEventListener("DOMContentLoaded", function () {

  // --- Nyelv lekérése ---
  const lang = document.documentElement.lang;

  // --- Szövegek nyelvenként ---
  const texts = {
    hu: {
      copy: "Másolás vágólapra →",
      copied: "Telefonszám másolva a vágólapra!"
    },
    de: {
      copy: "In Zwischenablage kopieren →",
      copied: "Telefonnummer in die Zwischenablage kopiert!"
    },
    en: {
      copy: "Copy to clipboard →",
      copied: "Phone number copied to clipboard!"
    }
  };

  const t = texts[lang] || texts.hu;

  function createPopup(emailLinkSelector) {

    const emailLink = document.querySelector(emailLinkSelector);

    if (!emailLink) return;

    const overlay = document.createElement("div");
    overlay.classList.add("overlay-popup");
    document.body.appendChild(overlay);

    const popup = document.createElement("div");
    popup.classList.add("email-popup");
    popup.innerHTML = `
      <button class="popup-close">X</button>
      <a href="tel:+36306282713">+36 30 628 2713</a>
      <button class="copy-btn">${t.copy}</button>
    `;

    document.body.appendChild(popup);

    const closeButton = popup.querySelector(".popup-close");
    const copyButton = popup.querySelector(".copy-btn");

    function openPopup(event) {
      event.preventDefault();

      overlay.style.display = "block";
      popup.style.display = "block";
    }

    emailLink.addEventListener("click", openPopup);

    closeButton.addEventListener("click", () => {
      overlay.style.display = "none";
      popup.style.display = "none";
    });

    overlay.addEventListener("click", () => {
      overlay.style.display = "none";
      popup.style.display = "none";
    });

    copyButton.addEventListener("click", () => {
      navigator.clipboard.writeText("+36306282713")
        .then(() => {
          alert(t.copied);
        });
    });
  }

  createPopup("#shopify-section-template--21639968751805__main .phone-box a");
  createPopup("#shopify-section-template--21639968751805__richtext_Eq9wf8 > div > div > div > div > div.richtext-btn > a");

});
















document.addEventListener('DOMContentLoaded', function () {
  // Trigger -> target szelektor páros minden template-hez
  var badgeMap = [
    {
      badgeSelector: '#shopify-section-template--20826984972477__main .jdgm-widget.jdgm-preview-badge.jdgm-preview-badge--with-link.jdgm--done-setup',
      targetSelector: '#shopify-section-template--20826984972477__apps_D9GUwQ'
    },
    {
      badgeSelector: '#shopify-section-template--21639968751805__main .jdgm-widget.jdgm-preview-badge.jdgm-preview-badge--with-link.jdgm--done-setup',
      targetSelector: '#shopify-section-template--21639968751805__apps_nhyBtK'
    }
  ];

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  document.addEventListener('click', function (e) {
    if (!isMobile()) return;

    badgeMap.forEach(function (pair) {
      var badgeEl = document.querySelector(pair.badgeSelector);
      if (!badgeEl) return;

      // Ellenőrizzük, hogy a kattintás a badge-en (vagy annak gyerekén) történt-e
      if (e.target === badgeEl || badgeEl.contains(e.target)) {
        var target = document.querySelector(pair.targetSelector);
        if (target) {
          e.preventDefault();
          e.stopPropagation();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }, true); // capture: true, hogy a jdgm saját linkje elé kerüljünk
});





document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('compare-drawer-button');
  const target = document.querySelector('.collection-topbar.sticky-topbar'); // állítsd a tényleges célelemre
  const originalParent = btn ? btn.parentElement : null;
  const originalNextSibling = btn ? btn.nextSibling : null;

  const mql = window.matchMedia('(max-width: 749px)'); // igazítsd a témád breakpointjához

  function positionButton(isMobile) {
    if (!btn || !target || !originalParent) return;

    if (isMobile) {
      if (btn.parentElement !== target) {
        target.appendChild(btn);
      }
    } else {
      if (btn.parentElement !== originalParent) {
        if (originalNextSibling) {
          originalParent.insertBefore(btn, originalNextSibling);
        } else {
          originalParent.appendChild(btn);
        }
      }
    }
  }

  positionButton(mql.matches);
  mql.addEventListener('change', (e) => positionButton(e.matches));
});





